import * as React from "react";
const SvgRemove = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M25.5996 16H6.39961", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgRemove;
